import { makeObservable, observable, action } from 'mobx'
// import api from '../api/api'
import { JSX } from 'react'
import { DeviceWidths } from '../shared/src/types/Miscs'
import I18nMd from '../components/PrettyMarkdownInput/I18nMd'



export interface clicktipStoreModel {
  clicktips:Clicktip[]
  setSeen: (i:number, status:boolean) => void
}

export type Clicktip = {
  id:string,
  content:JSX.Element|string,
  context:string,
  seen:boolean,
  showAfter?:string,
  sx?:any,
}

class clicktipStore {
  clicktips: Clicktip[] = [
    {
      id:'migration-to-single-p',
      'content': <I18nMd value="migration-to-single-p-info" />,
      context: '',
      seen:false,
    },
  ]

  constructor() {
    makeObservable(this, {
      clicktips: observable,
      setSeen: action,
    })
  }

  setSeen = (i:number, status:boolean) => {
    this.clicktips[i].seen = status
  }

}

const exportClicktipStore = new clicktipStore()

export default exportClicktipStore